<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="labClientOrganisationForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="labClientOrganisation" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                labClientOrganisationForm: () => import('../forms/LabClientOrganisationForm'),
                labClientOrganisation: () => import('../editViews/LabClientOrganisation'),
                headers: [
                    { text: 'User', value: 'userId', table: 'users', form: () => import('../forms/UserForm') },
                    { text: 'Name', value: 'name' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    users: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "userId", direction: "ascending" },
                ],
                itemsField: 'labClientOrganisations',
                editPageName: 'labClientOrganisation',
                apiMethod: 'LabClientOrganisations',
                claimName: 'LabClientOrganisations',
                formTitle: 'Lab Client Organisation',
                excelTitle: 'Lab Client Organisations',
                hasEditPage: true,
            }
        },
    };
</script>
